const wrapUrlWithServerUrl = (url: string) => {
    const serverUrl: string = process.env['REACT_APP_SERVER_URL'] ?? '';
    if (!serverUrl) throw new Error('REACT_APP_SERVER_URL not set');
    return `${serverUrl}/${url}`;
};

export default wrapUrlWithServerUrl;
